export enum ColorEnum {
  Primary = '#0062ff',
  Success = '#22C55E',
  Warning = '#F59E0B',
  Danger = '#EF4444',
}
